const transferType = Object.freeze({
  createNewInstructions: 'CREATE_NEW_INSTRUCTIONS',
  updateExistingInstructions: 'UPDATE_EXISTING_INSTRUCTIONS',
  replaceAllExistingInstructions: 'REPLACE_ALL_INSTRUCTIONS',
});

export default transferType;
